export const userContactMap = {
    489: 4170,
    3356: 4167, // matt
    3420: 4168, // joe
    4880: 4169, // tommy
    9196: 4376, // larry
}

export enum CenterOptionsOrigin {
    AccountPlan = 1,
    ProductPlan = 2
}